import React from 'react';
import dsn1 from '../../images/destination/bangkok-300x200.webp';
import dsn2 from '../../images/destination/chiangmai-300x200.webp';
import dsn3 from '../../images/destination/kohsamui-300x200.webp';
import dsn4 from '../../images/destination/kohkood-300x200.webp';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ActionButtons from '../ActionButtons';
import './style.css';
import Promotions from '../Promotions';

const Destination = () => {
  const { t, i18n } = useTranslation();

  const translateCityName = (cityName, locale) => {
    const translations = {
      en: {
        'bangkok': 'bangkok',
        'phuket': 'phuket',
        'chiang-mai': 'chiang-mai',
        'surat-thani': 'surat-thani',
        'koh-kood': 'koh-kood',
        'koh-kood-sueadum-go-pier-ao-salad': 'koh-kood-sueadum-go-pier-ao-salad',
        'bangkok-bus-terminal-ekkamai': 'bangkok-bus-terminal-ekkamai',
      },
      th: {
        'bangkok': 'กรุงเทพ',
        'phuket': 'ภูเก็ต',
        'chiang-mai': 'เชียงใหม่',
        'surat-thani': 'สุราษฎร์ธานี',
        'koh-kood': 'เกาะกูด',
        'koh-kood-sueadum-go-pier-ao-salad': 'เกาะกูด-ท่าเรือเสือดำโก-อ่าวสลัด',
        'bangkok-bus-terminal-ekkamai': 'กรุงเทพฯ สถานีขนส่งเอกมัย',
      }
    };

    return translations[locale]?.[cityName.toLowerCase()] || cityName;
  };

  // Use the current language dynamically
  const locale = i18n.language;

  const destinations = [
    {
      id: 1,
      image: dsn1,
      link: 'https://booking.ezseat.asia/bus/bangkok/phuket/6056'.replace(
        /\/bus\/([^/]+)\/([^/]+)\//,
        (_, from, to) => `/bus/${translateCityName(from, locale)}/${translateCityName(to, locale)}/`
      ),
      title: t('Bangkok ↔ Phuket'),
      frequency: t('routes.Daily'),
      price: '680THB',
    },
    {
      id: 2,
      image: dsn2,
      link: 'https://booking.ezseat.asia/bus/bangkok/chiang-mai/3494'.replace(
        /\/bus\/([^/]+)\/([^/]+)\//,
        (_, from, to) => `/bus/${translateCityName(from, locale)}/${translateCityName(to, locale)}/`
      ),
      title: t('Bangkok ↔ Chiang Mai'),
      frequency: t('routes.Daily'),
      price: '549THB',
    },
    {
      id: 3,
      image: dsn3,
      link: 'https://booking.ezseat.asia/bus/phuket/surat-thani/30843'.replace(
        /\/bus\/([^/]+)\/([^/]+)\//,
        (_, from, to) => `/bus/${translateCityName(from, locale)}/${translateCityName(to, locale)}/`
      ),
      title: t('Phuket ↔ Surat Thani'),
      frequency: t('routes.Daily'),
      price: '250THB',
    },
    {
      id: 4,
      image: dsn4,
      link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-ekkamai/koh-kood-sueadum-go-pier-ao-salad/256159'.replace(
        /\/bus\/([^/]+)\/([^/]+)\//,
        (_, from, to) => `/bus/${translateCityName(from, locale)}/${translateCityName(to, locale)}/`
      ),
      title: t('Bangkok ↔ Koh Kood'),
      frequency: t('routes.Daily'),
      price: '1129THB',
    },
  ];

  return (
    <div className="destination-area optimize-visibility">
      <ActionButtons />
      <Promotions />
      <div className="container" style={{ padding: '0 10px', maxWidth: '500px', margin: '0 auto' }}>

</div>

      <div className="container">
        <div className="wpo-section-title">
          <h2>{t('popular_destinations')}</h2>
        </div>
        <div className="row">
          {destinations.map((destination) => (
            <div key={destination.id} className="col-6 col-md-4 col-lg-3">
              <a
                href={destination.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="destination-link"
              >
                <div className="destination-item">
                  <div className="destination-img">
                    <img src={destination.image} alt={destination.title} loading="lazy" />
                  </div>
                  <div className="destination-content">
                    <div className="content-left">
                      <h5>{destination.title}</h5>
                      <small>{destination.frequency}</small>
                    </div>
                    <div className="content-right">
                      <h5>{destination.price}</h5>
                      <span>{t('starting')}</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
        <div className="btns text-center">
          <Link to="/destination2" className="theme-btn-s2" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            {t('discover_more')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Destination;
